/**
 * @prettier
 * @flow
 */
import { Environments } from 'src/constants/Environment';
import type { Environment } from 'src/constants/Environment';

export const environment: Environment = (process.env.REACT_APP_ENVIRONMENT: any) ?? Environments.PROD;
